import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { SearchToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto';
import { SearchToneResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneresponse';
import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';
// import { TextTransform } from '../../../toolkit/texttransform/texttransform';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { FeaturedCategoryDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';

export interface ProfiletunesCategoryAPIModel extends APIModel
{
    getProfiletunesCategories(): void;
}

export class ProfiletunesCategoryAPIModelImpl extends APIModelImpl implements ProfiletunesCategoryAPIModel
{
    private categroryId: string;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
        this.categroryId = applicationContext.getConfigurationSettings().getProperty("STATUS_TUNE_CATEGORYID");
    }

    getProfiletunesCategories(): void {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(20);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        searchToneDto.setCategoryId(parseInt(this.categroryId, 10));
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(0);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            // let listOfTones = searchToneResponse.getListOfSearchToneDtos().getListOfTones().map((toneDto: ToneDtoImpl) =>
            let listOfTones =searchToneResponse.getListOfSearchToneDtos().getListOfTones().map((toneDto: ToneDtoImpl) =>
            {
                toneDto.setArtistName(toneDto.getToneName());
                return toneDto;
            });

            let featuredCategoryDto = new FeaturedCategoryDtoImpl();
            featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.profile_tunes).toLocaleUpperCase());
            featuredCategoryDto.setListOfTones(listOfTones);

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), featuredCategoryDto);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
        //    this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
        //    searchToneResponse.getDescription(), undefined);
        let listOfTones = searchToneResponse.getListOfSearchToneDtos().getListOfTones().map((toneDto: ToneDtoImpl) =>
            {
                toneDto.setArtistName(toneDto.getToneName());
                return toneDto;
            });

            let featuredCategoryDto = new FeaturedCategoryDtoImpl();
            featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.profile_tunes).toLocaleUpperCase());
            featuredCategoryDto.setListOfTones(listOfTones);

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), featuredCategoryDto);

         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    /* private getListOfTones1()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("9");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk");
        tone1.setImgPath("http://placehold.it/120x120&text=image9");
        tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone2 = new ToneDtoImpl();
        tone2.setId("10");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk");
        tone2.setImgPath("http://placehold.it/120x120&text=image10");
        tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

        let tone3 = new ToneDtoImpl();
        tone3.setId("11");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk");
        tone3.setImgPath("http://placehold.it/120x120&text=image11");
        tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("12");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image12");
        tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone5 = new ToneDtoImpl();
        tone5.setId("13");
        tone5.setToneName("1234rsva");
        tone5.setArtistName("987ytrfgbnmk");
        tone5.setImgPath("http://placehold.it/120x120&text=image13");
        tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone6 = new ToneDtoImpl();
        tone6.setId("14");
        tone6.setToneName("1234rsva");
        tone6.setArtistName("987ytrfgbnmk");
        tone6.setImgPath("http://placehold.it/120x120&text=image14");

        let tone7 = new ToneDtoImpl();
        tone7.setId("15");
        tone7.setToneName("1234rsva");
        tone7.setArtistName("987ytrfgbnmk");
        tone7.setImgPath("http://placehold.it/120x120&text=image15");

        let tone8 = new ToneDtoImpl();
        tone8.setId("16");
        tone8.setToneName("1234rsva");
        tone8.setArtistName("987ytrfgbnmk");
        tone8.setImgPath("http://placehold.it/120x120&text=image16");

        return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8, tone7, tone7, tone7];
    }  */
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunesapimodel.ts